import React from 'react'
import PropTypes from 'prop-types'
import Back from 'components/common/Back'

const BOTBreadcrumbBackGlobalSearch = ({ handleNavigationBack }) =>
  <Back handler={ handleNavigationBack }><span data-at-back-label>Back to All Results</span></Back>

export default BOTBreadcrumbBackGlobalSearch

BOTBreadcrumbBackGlobalSearch.propTypes = {
  handleNavigationBack: PropTypes.func
}
